module.exports = __webpack_public_path__ + "img/Group_3126.83596bc0.svg";